// eslint-disable-next-line import/prefer-default-export
export const matchMobile = window.matchMedia('(min-width: 768px)');

export const { theme } = window;

export const rootPath =
  theme && theme.routes && theme.routes.root !== '/' ? `${theme.routes.root}/` : '/';
